import React, { useState } from 'react'
import AppDialog from '../../../components/app_dialog'
import { Button, TextArea } from '@cinesend/ui-kit'
import useStore from '../../../hooks/use_store'
import { useQueryClient } from '@tanstack/react-query'

export default function NewIssue({ type, cycleID, queryKey }) {
  const [openIssueModal, setOpenIssueModal] = useState(false)
  const [issue, setIssue] = useState('')
  const { createModel } = useStore()
  const queryClient = useQueryClient()

  const createIssue = () => {
    createModel.mutate({
      endpoint: 'issues',
      data: {
        description: issue,
        type: type,
        is_custom: 1,
        cycle_id: cycleID,
      },
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey])
        setOpenIssueModal(false)
      },
      onError: (error) => console.error(error.message),
    })
  }

  return (
    <div>
      <Button onClick={() => setOpenIssueModal(true)}>Create issue</Button>
      {openIssueModal && (
        <AppDialog
          title='Create new issue'
          onClose={() => {
            setIssue('')
            setOpenIssueModal(null)
          }}
          confirmText='Create issue'
          onConfirm={() => createIssue()}
        >
          <TextArea
            label='Describe the issue'
            placeholder='the issue...'
            value={issue}
            onChange={(e) => setIssue(e.target.value)}
            onKeyPress={(e) => e.charCode === 13 && !!e.target.value && createIssue()}
            autoFocus
            error={issue.length > 2000 ? 'The description is limited to 2000 characters' : undefined}
          />
        </AppDialog>
      )}
    </div>
  )
}
